export const getMccMnc = (operator: string) => ({
  mcc: operator.slice(0, 3),
  mnc: operator.slice(3),
});
